// extracted by mini-css-extract-plugin
export default {"premium":"fKtR_ezX"};